import { useStore } from 'Portal/src/stores'

export const useRentalTaggingEnabled = () => {
  const { portalConfigStore } = useStore()

  return portalConfigStore.portalConfig?.enableRentalTags ?? false
}
